var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { md: "6" } }, [_c("expired-certificates")], 1),
          _vm.$can("Read", "Invoice")
            ? _c(
                "b-col",
                { attrs: { md: "6" } },
                [_c("pending-received-invoices")],
                1
              )
            : _vm._e(),
          _vm._l(_vm.permitLicensesTypes(), function (permitLicenseType) {
            return _c(
              "b-col",
              { key: permitLicenseType.label, attrs: { md: "6" } },
              [
                _c("current-permit-licenses", {
                  attrs: { "permit-license-type": permitLicenseType },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }